import { request } from "./http";

/** params = { from: "YYYY-MM-DD", to: "YYYY-MM-DD" } */
export const fetchReport = (params, signal) => request("/reports/summary", { params, signal });
